import HeroBannerFrame from './HeroBannerFrame';

/**
 * Loading skeleton for the HeroBanner component.
 *
 * Renders inside the shared HeroBannerFrame so it occupies the exact same
 * area (aspect-ratio, background, rounded corners) as the real banner,
 * preventing any layout shift when the banner data arrives.
 */
const HeroBannerSkeleton = () => {
  return (
    <HeroBannerFrame>
      <div className="h-full w-full bg-[linear-gradient(90deg,rgba(45,47,51,0.1)_0%,rgba(45,47,51,0.06)_100%)]" />
    </HeroBannerFrame>
  );
};

export default HeroBannerSkeleton;
